const projects = [
  {
    title: 'Zip Practice',
    description:
      "A practice tool for LinkedIn's daily Zip puzzle. It generates random solvable boards at easy, medium, and hard difficulties. Puzzles can be shared by URL and the solution can be revealed at any time.",
    skills: ['React'],
    demoLink: 'https://eansengchang.com/zip-practice',
    codeLink: 'https://github.com/eansengchang/zip-practice',
    image: require('../../images/zip_practice.png'),
  },
  {
    title: 'ProofMap',
    description:
      "ProofMap takes a PDF of lecture notes and builds an interactive graph and list of theorems so you can see exactly how each result depends on the others.",
    skills: ['Python', 'React', 'LLMs'],
    demoLink: 'http://proofmap.info/',
    codeLink: 'https://github.com/krishte/ProofMap',
    image: require('../../images/proofmap.png'),
  },
  {
    title: 'Vision-Based Price Comparison',
    description:
      "A group project pursued in partnership with a company to train an object detection model to identify various electronics products with high accuracy, generate a text description of the product, and use web scraping to display similar products. All of this is done on a raspberry pi.",
    skills: ['Python', 'Raspberry Pi', 'Machine Learning'],
    demoLink: 'https://github.com/Seb-Potoniec/price-comparison',
    codeLink: 'https://github.com/Seb-Potoniec/price-comparison',
    image: require('../../images/price_comparison.png'),
  },
  {
    title: 'Craneon',
    description:
      "A full stack website I developed as part of an internship. Features include logging in, adding bookings and viewing the bookings on a map.",
    skills: ['Mongo', 'Express', 'React', 'Node'],
    demoLink: 'https://craneon.site/',
    codeLink: 'https://github.com/eansengchang/CraneOn-Website',
    image: require('../../images/craneon.png'),
  },
  {
    title: 'Chess Engine',
    description:
      'A Chess engine made in Java from scratch that follows UCI protocol and plays at a level comparable to 1700 elo rating.',
    skills: ['Java', 'Heroku'],
    demoLink: 'https://lichess.org/@/ESC_BOT',
    codeLink: 'https://github.com/eansengchang/Better-Java-Chess-Engine',
    image: require('../../images/chess_program.png'),
  },
  {
    title: 'Online Square Brawl',
    description:
      "An online multiplayer game inspired by Landfall's game using Socket.io to create lobbies that you can play with friends on the browser.",
    skills: ['Node', 'Socket.io', 'Heroku', 'HTML'],
    demoLink: 'https://squarebrawl.netlify.app/',
    codeLink: 'https://github.com/eansengchang/Multiplayer-Square-Brawl',
    image: require('../../images/square_brawl.png'),
  },
  {
    title: 'Discord Bot',
    description:
      'A utility bot for discord that provides detailed information on your server and tracks user activity. Also created a website using Pug that displays the statistics and commands of the bot dynamically in real time.',
    skills: ['Mongo', 'Express', 'Node', 'Bootstrap', 'Heroku', 'Pug'],
    demoLink: 'https://oogieboogiedashboard.herokuapp.com/',
    codeLink: 'https://github.com/eansengchang/OogieBoogieBot',
    image: require('../../images/discord_bot.png'),
  },
];

export default projects;
